// extracted by mini-css-extract-plugin
module.exports = {"container":"SideBar_container__2LBQ2","sidebarItems":"SideBar_sidebarItems__ldEFG","sidebarSearch":"SideBar_sidebarSearch__2Zb7K","links":"SideBar_links__enNNv"};